import { Navigate } from "react-router"

import Login from "../component/auth/Login"
import Register from "../component/auth/Register"
import adminRoutesConfig from "../config/adminRoutesConfig"

const routesConfig = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  adminRoutesConfig,
]

export default routesConfig
